export const TooltipStyles = {
  tooltip: {
    sx: {
      backgroundColor: '#000',
      "& ul": {
        paddingTop: 0,
        paddingLeft: '12px',
        margin: '2px',
      },
      "& ul li": {
        marginBottom: '2px',
        fontWeight: 'bold',
        paddingLeft: '4px'
      },
      "& ul li::marker": {
        content: '"["counter(list-item)"]"'
      }
    },
  }
}
